<template>
  <div class="t-container page">
    <!-- Heading -->
    <div class="page-heading" role="heading">
      <h1 class="page-heading__header">
        Bookings
      </h1>
      <div class="t-flex t-mx-auto t-my-2">
        <a :href="'/send-freight/new'">
          <button @click="" class="t-align-right t-bg-dodger-blue t-px-8 t-py-3">
            <span class="t-text-base t-font-bold t-text-white">
              <span class="t-text-sm">+</span>
              New Booking
            </span>
          </button>
        </a>
      </div>
    </div>

    <!-- Tab Menu -->
    <div class="tabs-container">
      <nav class="tabs-menu t-space-x-4 md:t-space-x-6">
        <a>
          <router-link :to="{ name: 'currentBookings' }" class="t-pb-2">
            Current
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'completedBookings' }" class="t-pb-2">
            Completed
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'cancelledBookings' }" class="t-pb-2">
            Cancelled
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'difotReportBookings' }" class="t-pb-2">
            DIFOT Report
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'manifestBookings' }" class="t-pb-2">
            Manifest
          </router-link>
        </a>
        <a>
          <router-link :to="{ name: 'exportBookings' }" class="t-pb-2">
            Export Bookings
          </router-link>
        </a>
      </nav>
    </div>
    <router-view v-bind="$attrs"></router-view>
  </div>
</template>

<script>
export default {
  name: "BookingsPage",
  description: "",
  components: {},
  data() {
    return {};
  },
  created() {}
};
</script>

<style scoped>
nav div a:active,
nav div a.router-link-active {
  border-bottom: 4px solid #3b82f6;
  font-weight: 600;
}
</style>
